<p class="rs-tit4">
  {{ faqTitle }}
</p>
<p>
  {{ 'bills.redesign.settingsAndFaq.faqContent' | translate }}
</p>
<hr *ngIf="hasSplitLine" />
<a
  (click)="onClickOfBillFaq()"
  data-cy="myBillGoToBillFaq"
  data-tms-event="button-click"
  data-tms-button-name="go to: mybill.faq"
  [attr.data-tms-button-zone]="zone"
  [attr.data-tms-message-info]="billingAccount?.accountNumber ?? ''"
  [attr.data-tms-context]="billingDocument?.reference ?? ''"
  class="rs-btn"
  >{{ 'bills.redesign.settingsAndFaq.faqLinkLabel' | translate }}
</a>
